import Controller from "../class.Controller";

/**
 * Stub class for animations.
 */
export default class Animation extends Controller {
	constructor(options) {
		super(options);
	}

	/**
	 * Starts an animation and returns a Promise.
	 * This Promise is extended with .scroll() to
	 * scroll to the BubbleView element if desired.
	 * @param {*} options
	 */
	start(options) {
		const {bubbleView} = options;
		const mainView = bubbleView.mainView;
		let promise;
		if (this.animationController.isEnabled()) {
			promise = this._animate(options);
		} else {
			promise = new Promise(async (resolve) => {
				bubbleView.$el.show();
				await mainView.scrollToTarget(bubbleView.$el, 0);
				resolve();
			});
		}
		// Extend the promise so we can chain .scroll().
		promise.options = options;
		promise.scroll = () => {
			var scrolledPromise = Promise.all([
				promise,
				mainView.scrollToTarget(
					bubbleView.$el,
					this.animationController.isEnabled() ? undefined : 0
				),
			]);
			scrolledPromise.options = options;
			return scrolledPromise;
		};

		return promise;
	}

	_animate() {}
}
